import TicketStatusPresetDropdown from "../dropdowns/presets/ticketStatus.preset.dropdown";
import AssetTypePresetDropdown from "../dropdowns/presets/assetType.preset.dropdown";
import ParentOptionsTextInput from "../inputs/texts/parentOptions.text.input";
import InfoIcon from "../icons/info.icon";
// CONSTANTS
import { IPAD_DEVICES } from "../../constants/devices/ipad.device.constant";
import { MACBOOK_DEVICES } from "../../constants/devices/macbook.device.constant";
import { PS5_DEVICES } from "../../constants/devices/ps5.device.constant";
import { XBOX_DEVICES } from "../../constants/devices/xbox.device.constant";
import { SURFACE_DEVICES } from "../../constants/devices/surface.device.constant";

const REPORT_FIELDS_MAP = {
  "Employee ROI": {
    dateRange: true,
  },
  "Aging Tickets": {
    dateRange: false,
    ticketStatuses: true,
    ltDate: true,
    assetTypes: true,
    ltDateInfo:
      "E.g. (1/1/2020 12:00 AM), would search tickets updated after this date.",
  },
  "Store Credit": {
    dateRange: true,
  },
  "Square Trade": {
    dateRange: true,
    parentOptionsTextInput: true,
  },
};

const CLASSNAMES = {
  fieldContainer:
    "p-2 rounded m-auto justify-center items-center flex flex-col bg-slate-200",
  fieldLabel: "font-ubuntuRegular",
};

const ReportFields = ({
  report = "",
  handleChange = () => {},
  formFields = {},
  setFormFields = () => {},
}) => {
  if (!report) return null;
  const reportType = REPORT_FIELDS_MAP[report];
  const {
    startDate = "",
    endDate = "",
    filename = "",
    ltDate = "",
    ticketStatuses = [],
    assets,
    models,
  } = formFields;

  return (
    <div className="gap-4 flex flex-row m-auto justify-center">
      {reportType?.dateRange && (
        <div className={CLASSNAMES.fieldContainer}>
          <label className={CLASSNAMES.fieldLabel}>Date Range</label>
          <div className="flex flex-row gap-2">
            <div className="">
              <input
                onChange={handleChange}
                type="date"
                name="startDate"
                value={startDate}
                className="rounded p-2"
              />
            </div>
            <div className="">
              <input
                onChange={handleChange}
                type="date"
                name="endDate"
                value={endDate}
                className="rounded p-2"
              />
            </div>
          </div>
        </div>
      )}
      {reportType?.ticketStatuses && (
        <div className={CLASSNAMES.fieldContainer}>
          <label className={CLASSNAMES.fieldLabel}>Ticket Statuses</label>
          <TicketStatusPresetDropdown
            formFields={formFields}
            setFormFields={setFormFields}
          />
        </div>
      )}
      {reportType?.ltDate && (
        <div className={CLASSNAMES.fieldContainer}>
          <div className="flex items-center gap-2 pb-2">
            <label className={CLASSNAMES.fieldLabel}>Last Update</label>
            {reportType?.ltDateInfo && (
              <InfoIcon
                tooltipPosition={"bottomLeft"}
                text={reportType.ltDateInfo}
              />
            )}
          </div>

          <input
            type="datetime-local"
            onChange={handleChange}
            placeholder="Date/Time"
            className="rounded p-2"
            name="ltDate"
            value={ltDate}
          />
        </div>
      )}
      {reportType?.assetTypes && (
        <div className={CLASSNAMES.fieldContainer}>
          <label className={CLASSNAMES.fieldLabel}>Asset Types</label>
          <AssetTypePresetDropdown
            formFields={formFields}
            setFormFields={setFormFields}
          />
        </div>
      )}
      {reportType?.parentOptionsTextInput && (
        <div className={CLASSNAMES.fieldContainer}>
          <label className={CLASSNAMES.fieldLabel}>Device Models</label>
          <ParentOptionsTextInput
            name="models"
            options={[
              { id: "ipad", name: "iPad", value: IPAD_DEVICES },
              { id: "macbook", name: "MacBook", value: MACBOOK_DEVICES },
              { id: "ps5", name: "PS5", value: PS5_DEVICES },
              { id: "xbox", name: "Xbox", value: XBOX_DEVICES },
              { id: "surface", name: "Surface", value: SURFACE_DEVICES },
            ]}
            formFields={formFields}
            setValue={setFormFields}
          />
        </div>
      )}
      <div className={CLASSNAMES.fieldContainer}>
        <label className={CLASSNAMES.fieldLabel}>Filename</label>
        <input
          type="text"
          onChange={handleChange}
          placeholder="Filename"
          className="rounded p-2"
          name="filename"
          value={filename}
        />
      </div>
    </div>
  );
};

export default ReportFields;
